// Module
var code = "<div class=\"ck-switch-ctn\" layout layout-align=\"start stretch\" ng-click=\"ctrl.active = !ctrl.active\" md-prevent-menu-close> <label class=\"switch\"> <input ng-model=\"ctrl.active\" type=\"checkbox\"/> <span class=\"slider\"></span> </label> <div class=\"noselect\" ng-transclude layout layout-align=\"start end\"></div> </div> ";
// Exports
module.exports = code;